export const navigationArrow = (
  <svg
    id="Navigarion_arrow"
    data-name="Navigarion arrow"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <rect id="Boundary" width="24" height="24" fill="none" />
    <path
      id="_Color"
      data-name=" ↳Color"
      d="M10.59,0,6,4.574,1.41,0,0,1.408,6,7.4l6-5.992Z"
      transform="translate(6 9.045)"
      fill="rgba(255,255,255,0.87)"
    />
  </svg>
);
